const MEALS_KEY = "mb_meals";
const PROFILE_KEY = "mb_profile";
const WATER_KEY = "mb_water";
const SEVEN_DAYS_MS = 7 * 24 * 60 * 60 * 1000;

function todayKey() {
  const d = new Date();
  return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`;
}

export const WATER_TARGET = 8;

export function loadWater() {
  try {
    const raw = JSON.parse(localStorage.getItem(WATER_KEY) || "{}");
    return raw.date === todayKey() ? raw.glasses || 0 : 0;
  } catch {
    return 0;
  }
}

export function setWater(n) {
  const glasses = Math.max(0, n);
  localStorage.setItem(WATER_KEY, JSON.stringify({ date: todayKey(), glasses }));
  return glasses;
}

// Serie idratazione: registra i giorni in cui l'obiettivo acqua è stato raggiunto.
const WATER_STREAK_KEY = "mb_water_streak";

export function recordWaterGoal() {
  let hist = {};
  try {
    hist = JSON.parse(localStorage.getItem(WATER_STREAK_KEY) || "{}");
  } catch {
    hist = {};
  }
  hist[dayStartOf(Date.now())] = 1;
  const cutoff = dayStartOf(Date.now()) - 60 * DAY_MS;
  Object.keys(hist).forEach((k) => {
    if (Number(k) < cutoff) delete hist[k];
  });
  localStorage.setItem(WATER_STREAK_KEY, JSON.stringify(hist));
}

export function getWaterStreak() {
  let hist = {};
  try {
    hist = JSON.parse(localStorage.getItem(WATER_STREAK_KEY) || "{}");
  } catch {
    hist = {};
  }
  const today0 = dayStartOf(Date.now());
  let day = hist[today0] ? today0 : today0 - DAY_MS;
  let streak = 0;
  while (hist[day]) {
    streak++;
    day -= DAY_MS;
  }
  return streak;
}


export const defaultProfile = {
  weight: 75,
  weightGoal: 70,
  diet: "",
  height: 180,
  age: 35,
  sex: "M",
  goal: "Perdere Peso",
  activity: "sedentario",
  macroArea: "",
  condition: "",
  drinkType: "superalcolico",
  drinkVolume: 0,
  allergies: [],
  allergyOther: "",
  habit: "",
  energy: "",
  intolerance: "",
};

export function loadProfile() {
  try {
    const raw = localStorage.getItem(PROFILE_KEY);
    if (!raw) return { ...defaultProfile };
    return { ...defaultProfile, ...JSON.parse(raw) };
  } catch {
    return { ...defaultProfile };
  }
}

export function saveProfile(profile) {
  localStorage.setItem(PROFILE_KEY, JSON.stringify(profile));
}

export function loadMeals() {
  try {
    const raw = localStorage.getItem(MEALS_KEY);
    const meals = raw ? JSON.parse(raw) : [];
    const now = Date.now();
    const fresh = meals.filter((m) => now - m.timestamp < SEVEN_DAYS_MS);
    if (fresh.length !== meals.length) {
      localStorage.setItem(MEALS_KEY, JSON.stringify(fresh));
    }
    return fresh.sort((a, b) => b.timestamp - a.timestamp);
  } catch {
    return [];
  }
}

export function addMeal(meal) {
  const meals = loadMeals();
  const entry = { ...meal, id: meal.id || crypto.randomUUID(), timestamp: Date.now() };
  meals.unshift(entry);
  localStorage.setItem(MEALS_KEY, JSON.stringify(meals));
  return entry;
}

export function deleteMeal(id) {
  const meals = loadMeals().filter((m) => m.id !== id);
  localStorage.setItem(MEALS_KEY, JSON.stringify(meals));
  return meals;
}

export function updateMeal(id, patch) {
  const meals = loadMeals().map((m) => (m.id === id ? { ...m, ...patch } : m));
  localStorage.setItem(MEALS_KEY, JSON.stringify(meals));
  return meals.sort((a, b) => b.timestamp - a.timestamp);
}

// Storico leggero dei soli totali calorici giornalieri (ultimi 7 giorni),
// indipendente dall'auto-pulizia dei pasti a 72h.
const DAILY_CAL_KEY = "mb_daily_cal";
const DAY_MS = 24 * 60 * 60 * 1000;

function dayStartOf(ts) {
  const d = new Date(ts);
  d.setHours(0, 0, 0, 0);
  return d.getTime();
}

export function recordDailyCalories() {
  const meals = loadMeals();
  const byDay = {};
  meals.forEach((m) => {
    const k = dayStartOf(m.timestamp);
    byDay[k] = (byDay[k] || 0) + (m.calories || 0);
  });
  let hist = {};
  try {
    hist = JSON.parse(localStorage.getItem(DAILY_CAL_KEY) || "{}");
  } catch {
    hist = {};
  }
  Object.entries(byDay).forEach(([k, v]) => {
    hist[k] = v;
  });
  const cutoff = dayStartOf(Date.now()) - 6 * DAY_MS;
  Object.keys(hist).forEach((k) => {
    if (Number(k) < cutoff) delete hist[k];
  });
  localStorage.setItem(DAILY_CAL_KEY, JSON.stringify(hist));
  return hist;
}

export function loadDailyHistory(days = 7) {
  let hist = {};
  try {
    hist = JSON.parse(localStorage.getItem(DAILY_CAL_KEY) || "{}");
  } catch {
    hist = {};
  }
  const today0 = dayStartOf(Date.now());
  const out = [];
  for (let off = days - 1; off >= 0; off--) {
    const k = today0 - off * DAY_MS;
    out.push({ dayStart: k, cals: hist[k] || 0 });
  }
  return out;
}

// Storico leggero del peso giornaliero (ultimi 7 giorni).
const WEIGHT_KEY = "mb_weight_log";

export function recordWeight(kg) {
  const w = parseFloat(kg);
  if (!w || w <= 0) return;
  let hist = {};
  try {
    hist = JSON.parse(localStorage.getItem(WEIGHT_KEY) || "{}");
  } catch {
    hist = {};
  }
  hist[dayStartOf(Date.now())] = Math.round(w * 10) / 10;
  const cutoff = dayStartOf(Date.now()) - 6 * DAY_MS;
  Object.keys(hist).forEach((k) => {
    if (Number(k) < cutoff) delete hist[k];
  });
  localStorage.setItem(WEIGHT_KEY, JSON.stringify(hist));
}

export function loadWeightHistory(days = 7) {
  let hist = {};
  try {
    hist = JSON.parse(localStorage.getItem(WEIGHT_KEY) || "{}");
  } catch {
    hist = {};
  }
  const today0 = dayStartOf(Date.now());
  const out = [];
  for (let off = days - 1; off >= 0; off--) {
    const k = today0 - off * DAY_MS;
    out.push({ dayStart: k, kg: hist[k] != null ? hist[k] : null });
  }
  return out;
}

const FAVORITES_KEY = "mb_favorites";

export function loadFavorites() {
  try {
    return JSON.parse(localStorage.getItem(FAVORITES_KEY) || "[]");
  } catch {
    return [];
  }
}

export function isFavorite(id) {
  return loadFavorites().some((f) => f.id === id);
}

export function addFavorite(fav) {
  const list = loadFavorites().filter((f) => f.id !== fav.id);
  list.unshift({ ...fav, savedAt: Date.now() });
  localStorage.setItem(FAVORITES_KEY, JSON.stringify(list));
  return list;
}

export function removeFavorite(id) {
  const list = loadFavorites().filter((f) => f.id !== id);
  localStorage.setItem(FAVORITES_KEY, JSON.stringify(list));
  return list;
}
